import React from "react";
import { Modal, Button, Form, Input } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const DeleteConfirmationModal = ({
  visible,
  onCancel,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
  itemName = "",
  loading = false,
  okText = "Delete",
  cancelText = "Cancel",
  width = 400,
  input = false,
}) => {
  const [form] = Form.useForm();
  const handleOk = () => {
    if (input) {
      form
        .validateFields()
        .then((values) => {
          onConfirm(values.delete_reason);
          form.resetFields();
        })
        .catch(() => {});
    } else {
      onConfirm();
    }
  };
  return (
    <Modal
      title={title}
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={{
        danger: true,
        loading: loading,
      }}
      centered={true}
      width={width}
    >
      <div style={{ textAlign: "center" }}>
        <ExclamationCircleOutlined
          style={{
            fontSize: "48px",
            color: "#ff4d4f",
            marginBottom: "16px",
          }}
        />
        <p
          style={{
            fontSize: "16px",
            marginBottom: "8px",
            fontWeight: "500",
            color: "black",
          }}
        >
          {message}
        </p>
        {itemName && (
          <p
            style={{
              color: "white",
              fontSize: "14px",
              margin: "0px",
              fontStyle: "italic",
            }}
          >
            "{itemName}"
          </p>
        )}

        {/* ✅ CONDITIONAL INPUT */}
        {input && (
          <Form form={form} layout="vertical">
            <Form.Item
              name="delete_reason"
              label="Delete Reason"
              rules={[
                {
                  required: true,
                  message: "Delete reason is required",
                },
              ]}
            >
              <Input.TextArea placeholder="Enter delete reason" rows={3} />
            </Form.Item>
          </Form>
        )}
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
